import { StackProps } from '@mui/system';
import { PropsWithChildren } from 'react';

import {
  ConversationContainer,
  conversationLayoutClasses as classes,
  InputContainer,
  Root,
} from './ConversationLayout.styled';

interface ConversationLayoutProps extends Omit<StackProps, 'slotProps'> {
  input?: React.ReactNode;
  disclaimer?: React.ReactNode;
}

export const ConversationLayout = ({
  children,
  input,
  disclaimer,
  ...stackProps
}: PropsWithChildren<ConversationLayoutProps>) => {
  return (
    <Root {...stackProps}>
      <ConversationContainer className={classes.conversationContainer}>{children}</ConversationContainer>
      {input || disclaimer ? (
        <InputContainer className={classes.inputContainer}>
          {input}
          {disclaimer}
        </InputContainer>
      ) : null}
    </Root>
  );
};
